import { isEndPartnershipCommandData } from '@festina/legalentity-general-types/legalentity'
import type { Optional } from '@festina-life/core'
import type { CommandActionVariant } from '@festina-life/ui/theme'

import type { AnyCommandVersion } from '../components/commandActions/types'
import { useHook } from '../lenteHooks'
import type { EventVersionWithCommandType } from './useFilterCommands'

export const useResolvePartnershipIdForCommandData = ({
  commandActionVariant,
  eventVersionWithCommand,
}: {
  eventVersionWithCommand?: Optional<
    EventVersionWithCommandType<AnyCommandVersion>
  >
  commandActionVariant: CommandActionVariant
}) => {
  const commandData = eventVersionWithCommand?.commandVersion?.commandData
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const { data: personVersion } = useHook(
    'fetchers.crm.useFetchPersonVersionLatest',
  )(
    {
      tenantId,
      personId: ownerId,
    },
    {
      enabled: commandActionVariant === 'create',
    },
  )

  if (commandActionVariant === 'create') {
    return personVersion?.partnershipVersion?.partnershipId ?? ''
  }

  return isEndPartnershipCommandData(commandData)
    ? (commandData.partnershipId ?? '')
    : ''
}
